export const ACCOUNT_ANALYTICS_ACTION = 'ACCOUNT_ANALYTICS_ACTION';
export const ACCOUNT_EVENTS_ATTACHED = 'ACCOUNT_EVENTS_ATTACHED';

export function accountAnalyticsAction(e) {
    return{
        type: ACCOUNT_ANALYTICS_ACTION,
        meta: {
            event: e
        }
    }
}

export function accountEventsAttached() {
    return{
        type: ACCOUNT_EVENTS_ATTACHED
    }
}
